module.exports = __webpack_public_path__ + "static/WpK_salon_pakiet_zloty-d0bf5e84a5a3d543ca77b7987abdd7a9.jpg";